var _mask, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBgGridDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 941,
    height: 649,
    viewBox: "0 0 941 649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 0,
    width: 800,
    height: 649
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    width: 800,
    height: 649,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-51.8511 385.133L450.557 639.86",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M450.561 137.054L-51.8477 391.787",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-16.8789 367.401L485.53 622.132",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M485.53 154.776L-16.8789 409.502",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M18.0898 349.668L520.498 604.402",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M520.501 172.507L18.0898 427.236",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M53.0586 331.941L555.467 586.671",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M555.47 190.236L53.0586 444.968",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M88.0273 314.208L590.439 568.938",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M590.439 207.966L88.0303 462.697",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M123 296.479L625.408 551.211",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M625.408 225.697L123 480.426",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M157.968 278.753L660.377 533.479",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M660.38 243.426L157.968 498.16",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M192.937 261.021L695.349 515.749",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M695.349 261.156L192.94 515.886",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M227.906 243.29L730.317 498.022",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M730.317 278.89L227.909 533.617",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M262.875 225.56L765.286 480.291",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M765.286 296.616L262.878 551.35",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M297.847 207.829L800.255 462.559",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M800.258 314.346L297.85 569.076",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M332.815 190.098L835.227 444.83",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M835.227 332.08L332.818 586.808",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M367.784 172.37L870.196 427.098",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M870.196 349.806L367.787 604.54",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M402.753 154.639L905.164 409.366",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M905.165 367.538L402.756 622.268",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M437.725 136.907L940.134 391.639",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M940.137 385.27L437.729 640",
    stroke: "#8492C4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.5102,
    height: 40.2571,
    transform: "matrix(0.86604 -0.499974 0.86604 0.499974 129 423.563)",
    fill: "#EDE7F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37.5024,
    height: 37.2681,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 131.589 425.058)",
    fill: "#B39DDB",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9558,
    height: 40.6999,
    transform: "matrix(0.857577 -0.514355 0.857577 0.514355 515.931 566.066)",
    fill: "#E3F2FD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 37.9149,
    height: 37.678,
    transform: "matrix(0.857576 -0.514356 0.857576 0.514356 518.522 567.62)",
    fill: "#90CAF9",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9406,
    height: 40.6848,
    transform: "matrix(0.857576 -0.514356 0.857576 0.514356 269 177.39)",
    fill: "#E3F2FD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 37.9009,
    height: 37.6641,
    transform: "matrix(0.857575 -0.514358 0.857575 0.514358 271.59 178.943)",
    fill: "#90CAF9",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgGridDark);
export default __webpack_public_path__ + "static/media/img-bg-grid-dark.49cce379f124edfab916561e2ca8e9eb.svg";
export { ForwardRef as ReactComponent };